// extracted by mini-css-extract-plugin
export var banner = "GameConceptDisplayMessage-module__banner___lcY6D";
export var bannerError = "GameConceptDisplayMessage-module__bannerError___nwEuC";
export var bannerWarning = "GameConceptDisplayMessage-module__bannerWarning___6OkrC";
export var columnAlign = "GameConceptDisplayMessage-module__columnAlign___+c5+X";
export var description = "GameConceptDisplayMessage-module__description___nJTgK";
export var iconWrapper = "GameConceptDisplayMessage-module__iconWrapper___ijxs+";
export var iconWrapperError = "GameConceptDisplayMessage-module__iconWrapperError___I+XNn";
export var iconWrapperWarning = "GameConceptDisplayMessage-module__iconWrapperWarning___0P7n7";
export var textWrapper = "GameConceptDisplayMessage-module__textWrapper___HN+ER";
export var title = "GameConceptDisplayMessage-module__title___ayDNa";